import { FC, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

const ErrorBoundary: FC = () => {
  const error = useRouteError() as Error;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div>
      <h1>Oops! Something went wrong.</h1>

      {isRouteErrorResponse(error) ? (
        <div>
          <h2>{error.status}</h2>
          <p>{error.statusText}</p>
        </div>
      ) : (
        <div>
          <h2>{(error as { message: string })?.message}</h2>
        </div>
      )}
    </div>
  );
};

export { ErrorBoundary };
